<template>
    <div class="uk-card uk-card-default uk-card-small uk-card-body">
        <div class="store-locator__search">
            <div class="uk-grid-collapse" uk-grid data-uk-rr-stores="search-wrapper">
                <div class="uk-width-expand uk-form-controls">
                    <input v-model="searchField" v-on:keyup="checkEmpty()" class="uk-input" type="text" id="searchField" value="" :placeholder="$t('rubinred.store-locator.model.search_input')" data-uk-rr-stores="search-input" required>
                </div>
                <div class="uk-width-auto" data-uk-rr-stores="find-position-wrapper">
                    <button v-on:click="getPosition()" class="uk-button uk-button-secondary" data-uk-rr-stores="find-position-button">
                        <i class="fal fa-location"></i>
                    </button>
                </div>
                <div class="uk-width-auto">
                    <button class="uk-button uk-button-primary uk-width-1-1" data-uk-rr-stores="search-button">
                        <i class="fal fa-search"></i> {{ $t('rubinred.store-locator.actions.search') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        searchAutocomplete: false,
        searchField: '',
      }
    },
    methods: {
      checkEmpty: _.debounce(function () {
        let self = this;
        if (self.searchField == '') {
          self.$root.$emit('rubinred.store-locator.search', null);
        }
      }, 500),
    },
    mounted() {
      let searchField = document.querySelector('#searchField');
      let self = this;
      //on page loaded load autocomplete
      window.addEventListener('load', () => {
        if (searchField) {
          this.searchAutocomplete = new google.maps.places.Autocomplete(searchField);
          this.searchAutocomplete.setFields(
            ['address_components', 'geometry', 'icon', 'name']);
          this.searchAutocomplete.addListener('place_changed', function () {
            self.$root.$emit('rubinred.store-locator.search', self.searchAutocomplete.getPlace());
          })
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/store-locator/assets/js/components/StoreLocatorSearch.vue